export default __webpack_public_path__ + "static/media/react.5efae81b.png";